/**
 * ConnectionStatusBanner - Shows amber warning when backend connection is lost.
 *
 * Renders nothing when connected. Matches the existing Print Agent offline
 * warning pattern (PrintStationPage.tsx) for visual consistency.
 */

import { WifiOff } from 'lucide-react';
import type { HeartbeatState } from '@/hooks/useBackendHeartbeat';

interface ConnectionStatusBannerProps {
  heartbeat: HeartbeatState;
}

export function ConnectionStatusBanner({ heartbeat }: ConnectionStatusBannerProps) {
  if (heartbeat.connected) return null;

  return (
    <div role="alert" className="flex items-center gap-3 p-3 bg-amber-50 dark:bg-amber-950/30 border border-amber-200 dark:border-amber-800 rounded-lg animate-enter">
      <WifiOff className="h-5 w-5 text-amber-600 dark:text-amber-400 shrink-0" aria-hidden="true" />
      <div className="min-w-0">
        <p className="text-sm font-semibold text-amber-800 dark:text-amber-200">
          Server connection lost
        </p>
        <p className="text-xs text-amber-700 dark:text-amber-300">
          Scans may not be saved. Reconnecting automatically...
        </p>
      </div>
    </div>
  );
}
